import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import LoginFormIntranet from "./LoginFormIntranet";

const Form4 = ({ heading, subHeading, link, image }) => {
	return (
		<section>
			<Container className="pt-5 pt-xl-0 " fluid>
				{/* <Row>
					<Col className="d-md-none px-0 mx-0" md={6}>
						{image && (
							<GatsbyImage
								style={{ maxHeight: "300px" }}
								image={image}
								alt="Intranet Login"
								className="w-100 mb-5"
							/>
						)}
					</Col>
				</Row> */}
				<Row className="justify-content-center align-items-center ">
					<Col className="px-xl-9 px-md-5 " md={8} lg={6}>
						<div className="pb-5">
							<h1
								style={{ color: "#562A79" }}
								className="text-center display-5 pb-1"
							>
								{heading}
							</h1>
							{subHeading && (
								<p className=" text-center">
									<span className="calibri">
										{subHeading}
										{link && (
											<a
												href={link?.url}
												target={link?.target || "_blank"}
												className="purple-link fw-bold ps-1"
											>
												{link?.title || "Click here"}
											</a>
										)}
									</span>
								</p>
							)}
						</div>
						<div className="px-xl-7">
							<LoginFormIntranet />
						</div>
					</Col>
					<Col className="d-none d-xl-block" md={6}>
						{image && (
							<GatsbyImage
								image={image}
								alt="Intranet Login"
								className="w-100 "
							/>
						)}
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Form4;
